import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getCookie } from 'owa-service/lib/universalCookies';
import { hasQueryStringParameter, getQueryStringParameter } from 'owa-querystring';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var astScriptUrl;
export var supportedMarkets = [
    'ar-sa',
    'ar-ae',
    'ar-eg',
    'da-dk',
    'de-at',
    'de-ch',
    'de-de',
    'el-gr',
    'en-ae',
    'en-ar',
    'en-at',
    'en-au',
    'en-br',
    'en-ca',
    'en-ch',
    'en-cl',
    'en-co',
    'en-de',
    'en-dk',
    'en-eg',
    'en-fi',
    'en-gb',
    'en-gr',
    'en-hk',
    'en-id',
    'en-ie',
    'en-in',
    'en-mx',
    'en-my',
    'en-nl',
    'en-no',
    'en-nz',
    'en-pe',
    'en-ph',
    'en-pl',
    'en-pt',
    'en-ru',
    'en-sa',
    'en-se',
    'en-sg',
    'en-th',
    'en-tr',
    'en-us',
    'en-vn',
    'en-za',
    'es-ar',
    'es-cl',
    'es-co',
    'es-cr',
    'es-do',
    'es-ec',
    'es-es',
    'es-gt',
    'es-mx',
    'es-pe',
    'es-us',
    'es-ve',
    'fi-fi',
    'fil-ph',
    'fr-be',
    'fr-ca',
    'fr-ch',
    'fr-fr',
    'id-id',
    'it-it',
    'ja-jp',
    'ko-kr',
    'ms-my',
    'nb-no',
    'nl-be',
    'nl-nl',
    'pl-pl',
    'pt-br',
    'pt-pt',
    'ru-ru',
    'sv-se',
    'th-th',
    'tr-tr',
    'vi-vn',
    'zh-cn',
    'zh-hk',
    'zh-sg',
    'zh-tw',
];
// We do not serve Ad for the following markets
export var embargoedMarkets = ['ar-ir', 'es-cu', 'ko-kp', 'ar-sy', 'en-su', 'uk-ua'];
var countryDefaultMarkets = {
    ae: 'ar-ae',
    ar: 'es-ar',
    at: 'de-at',
    au: 'en-au',
    be: 'fr-be',
    br: 'pt-br',
    ca: 'en-ca',
    ch: 'de-ch',
    cl: 'es-cl',
    cn: 'zh-cn',
    co: 'es-co',
    cr: 'es-cr',
    cu: 'es-cu',
    de: 'de-de',
    dk: 'da-dk',
    do: 'es-do',
    ec: 'es-ec',
    eg: 'ar-eg',
    es: 'es-es',
    fi: 'fi-fi',
    fr: 'fr-fr',
    gb: 'en-gb',
    uk: 'en-gb',
    gr: 'el-gr',
    gt: 'es-gt',
    hk: 'zh-hk',
    id: 'id-id',
    ie: 'en-ie',
    in: 'en-in',
    ir: 'ar-ir',
    it: 'it-it',
    jp: 'ja-jp',
    kp: 'ko-kp',
    kr: 'ko-kr',
    mx: 'es-mx',
    my: 'ms-my',
    nl: 'nl-nl',
    no: 'nb-no',
    nz: 'en-nz',
    pe: 'es-pe',
    ph: 'fil-ph',
    pl: 'pl-pl',
    pt: 'pt-pt',
    ru: 'ru-ru',
    sa: 'ar-sa',
    se: 'sv-se',
    sg: 'en-sg',
    su: 'en-su',
    th: 'th-th',
    tr: 'tr-tr',
    tw: 'zh-tw',
    ua: 'uk-ua',
    us: 'en-us',
    ve: 'es-ve',
    vn: 'vi-vn',
    za: 'en-za',
};
var adMarketPublishGroupCode;
export function calculateAdMarketPublishGroupCode() {
    if (hasQueryStringParameter('ormarket')) {
        return getQueryStringParameter('ormarket');
    }
    var userConfiguration = getUserConfiguration();
    var userCulture = userConfiguration.SessionSettings.UserCulture;
    // If AdMarket is null which means user does not select any country in the MSA live profile,
    // we will use UserCulture and fall back to en-us if UserCulture is not available as well
    if (!userConfiguration.AdMarket || !/^[a-zA-z\-]*$/.test(userConfiguration.AdMarket)) {
        return userCulture ? userCulture.toLowerCase() : 'en-us';
    }
    var adMarket = userConfiguration.AdMarket.toLowerCase();
    // If the server-side emit user Ad market is already in the supported market list
    // (which is the majority case and the most ideal case, we will use it directly)
    if (supportedMarkets.indexOf(adMarket) > -1) {
        return adMarket;
    }
    return countryDefaultMarkets[adMarket.split('-')[1]] || adMarket;
}
export function IsPremiumConsumerUser() {
    return getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
}
export function IsChildConsumerUser() {
    return getUserConfiguration().IsConsumerChild;
}
export function getAdMarketPublishGroupCode() {
    // Cache the Ad market as it will not change in one OWA session
    if (typeof adMarketPublishGroupCode != 'undefined') {
        return adMarketPublishGroupCode;
    }
    adMarketPublishGroupCode = calculateAdMarketPublishGroupCode();
    return adMarketPublishGroupCode;
}
export function getMarketParts(usermarket) {
    if (usermarket != null) {
        return usermarket.toUpperCase().split('-');
    }
    return [];
}
export function getMarketCountryCode(usermarket) {
    return getMarketParts(usermarket)[1] || 'US';
}
export function getMuidCookie() {
    return getCookie('MUID');
}
export function getToptOutCookie() {
    return !!getCookie('TOptOut');
}
export function getAstScriptUrl() {
    // Cache astScript Url during the whole OWA session
    if (astScriptUrl) {
        return astScriptUrl;
    }
    astScriptUrl =
        getQueryStringParameter('anjs') ||
            (isControlFeatureEnabled('fwk-gdprAdsPrefs')
                ? 'https://acdn.adnxs.com/ast/static/0.16.1/ast.js'
                : 'https://acdn.adnxs.com/ast/static/0.15.1/ast.js');
    return astScriptUrl;
}
// This is only used for test
export function setAdMarketPublishGroupCodeValue(value) {
    adMarketPublishGroupCode = value;
}
//# sourceMappingURL=sharedAdsUtils.js.map